export default {
  sm: `
    Over 350 local network 
    providers joined us 
    for our cloud service
  `,
  md: `
    Over 350 local network 
    providers joined us 
    for our cloud service
  `,
  lg: `
    Over 350 local network 
    providers joined us 
    for our cloud service
  `,
  xxl: `
    Over 350 local network providers 
    joined us for our cloud service
  `,
};
